<template>
  <div class="page-container-summary">
    <LandingBar active="portfolio" />
    <v-dialog v-model="vError" persistent max-width="700">
      <v-card>
        <v-card-title class="text-h5"> Error </v-card-title>
        <v-card-text>There was an error with your transaction:</v-card-text>
        <v-card-text
          ><code>{{ vMessage }}</code></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="vError = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vCue" persistent max-width="700">
      <v-card>
        <v-card-title class="text-h5"> Success </v-card-title>
        <v-card-text>Your transaction was validated:</v-card-text>
        <v-card-text>
          <code>{{ vMessage2 }}</code>
        </v-card-text>
        <v-card-text>
          <code>{{ vMessage3 }}</code>
        </v-card-text>
        <v-card-text>
          <code>{{ vMessage4 }}</code>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="vCue = false"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="buy-wrapper summary-tab">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="summary-middle">
        <div class="summary-middle-table table-wrapper table-wrapper2">
          <h3 class="table-headline2">User transaction history</h3>
          <v-data-table
            :header-props="{ sortIcon: icons.mdiArrowUpBold }"
            :headers="headers"
            :items="getOffersList"
            :search="search"
          >
            <template v-slot:item.requestDateFrom="{ item }">
              <div>{{ item.requestDateFrom }} {{ item.requestTimeFrom }}</div>
            </template>
            <template v-slot:item.requestDateTo="{ item }">
              <div>{{ item.requestDateTo }} {{ item.requestTimeTo }}</div>
            </template>
            <template v-slot:item.acceptedVolume="{ item }">
              <div>{{ item.acceptedVolume }} {{ item.acceptedVolume && 'KW' }}</div>
            </template>
            <template v-slot:item.realVolume="{ item }">
              <div>{{ item.realVolume }} {{ item.realVolume && 'KWh' }}</div>
            </template>
            <template v-slot:item.id="{ item }">
              <v-btn
                class="validate-button"
                small
                :loading="loader === item.bcId"
                color="#58c26d"
                :disabled="compareTime(item)"
                v-on:click="validatePurchase(item)"
                >Validate</v-btn
              >
            </template></v-data-table
          >
        </div>
      </div>
      <div class="summary-upper">
        <div class="summary-left">
          <h1 class="table-headline2">Summary</h1>
          <div class="balance-flex">
            <div class="balance1">
              <div class="summary-header">Current Coin Balance</div>
              <div class="balance" id="balance_eth">ETH</div>
              <div class="conversion" id="pricePerETH">(1 ETH = 8000 EURO)</div>
              <v-icon class="summary-icon">{{ icons.mdiCurrencyEur }}</v-icon>
            </div>
            <div class="balance1">
              <div class="summary-header">Current Balance</div>
              <div class="balance" id="balance">&euro;</div>
              <v-icon class="summary-icon">{{ icons.mdiScaleBalance }}</v-icon>
            </div>
          </div>
        </div>
        <div class="summary-right">
          <v-btn
            elevation="2"
            color="#59c26b"
            class="transfer-button"
            v-on:click="buyCoin"
          >
            <v-icon left> {{ icons.mdiRepeat }} </v-icon>Buy coin</v-btn
          >
          <div class="summary-graph">
            <SummaryChart />
          </div>
        </div>
      </div>
      <!-- <div class="offer-middle">
        <h3 class="table-headline2">Offer & request status</h3>
        <StatusChart
          :offer="getOfferStatus"
          :req="getReqStatus"
          :key="getOfferStatus"
          v-if="getReqStatus.length > 0"
        />
      </div> -->
      <!-- <div class="offer-middle">
        <h3 class="table-headline2">Production and consumption</h3>
        <OfferReqChart
          :production="getProduction"
          :consumption="getConsumption"
          :key="getProduction"
          v-if="getConsumption.length > 0"
        />
      </div> -->
      <div class="summary-middle">
        <div class="summary-middle-table table-wrapper" id="trans_1">
          <h3 class="table-headline2">Blockchain transaction history</h3>
          <table id="transactions">
            <thead>
              <tr>
                <th>Event</th>
                <th>From</th>
                <th>Asset Name</th>
                <th>Capacity</th>
                <th>Price</th>
                <th>Company Type</th>
                <th>City</th>
                <th>Date</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <!-- <div class="summary-button-wrapper">
        <button class="offer-add-button" @click="userHistory">
          Users View
        </button>
        <button class="offer-add-button" @click="offerHistory">
          Admin's View
        </button>
      </div> -->
      <p></p>

      <div class="page-bubble transactions" style="display: none">
        <h3 class="table-headline">User Transaction history</h3>
        <table id="transactions" cellspacing="0">
          <thead>
            <tr>
              <th>Event</th>
              <th>From</th>
              <th>Asset Name</th>
              <th>Capacity</th>
              <th>Price</th>
              <th>Company Type</th>
              <th>City</th>
              <th>Date</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="page-bubble transactions" style="display: none" id="trans_2">
        <h3 class="table-headline">Blockchain transaction history</h3>
        <table id="order_transactions">
          <thead>
            <tr>
              <th>Event</th>
              <th>From</th>
              <th>Asset Name</th>
              <th>Capacity</th>
              <th>Price</th>
              <th>Company Type</th>
              <th>City</th>
              <th>Date</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LandingBar from "../components/Common/LandingBarDSO.vue";
import SummaryChart from "../components/Charts/SummaryChart";
import StatusChart from "../components/Charts/StatusChart";
import OfferReqChart from "../components/Charts/OfferReqChart";
import { mdiScaleBalance, mdiCurrencyEur, mdiRepeat } from "@mdi/js";
import OfferDataService from "../services/OfferDataService";
import axios from "axios";
import moment from "moment";
export default {
  components: { LandingBar, SummaryChart, OfferReqChart, StatusChart },
  data() {
    return {
      icons: {
        mdiScaleBalance,
        mdiCurrencyEur,
        mdiRepeat,
      },
      offersList: [],
      vError: false,
      loader: "",
      vMessage: "",
      vMessage2: "",
      vCue: false,
      loading: false,
      now: new Date(),
      production: [],
      consumption: [],
      offerStatus: [],
      reqStatus: [],
      bread: [
        {
          text: "Portfolio Management",
          disabled: false,
        },
        {
          text: "Summary",
          disabled: false,
        },
      ],
      headers: [
        {
          text: "Offer code",
          align: "start",
          value: "offerCode",
        },
        { text: "Req code", value: "requestCode", sortable: false },
        {
          text: "Loc code",
          value: "requestLocationCode",
          sortable: true,
        },
        { text: "Date from", value: "requestDateFrom", sortable: true },
        { text: "Date to", value: "requestDateTo", sortable: true },
        { text: "Delivery rate", value: "deliveryRate", sortable: true },
        { text: "Accepted vol", value: "acceptedVolume", sortable: true },
        // { text: "Accepted price", value: "acceptedPrice", sortable: true },
        { text: "Delivery vol", value: "realVolume", sortable: true },
        { text: "Final price", value: "realPrice", sortable: true },
        { text: "", value: "id", sortable: false },
      ],
    };
  },
  computed: {
    getOffersList() {
      return this.offersList;
    },
    getConsumption() {
      return this.consumption;
    },
    getProduction() {
      return this.production;
    },
    getOfferStatus() {
      return this.offerStatus;
    },
    getReqStatus() {
      return this.reqStatus;
    },
  },
  methods: {
    async validatePurchase(item) {
      this.loader = item.bcId;
      await OfferDataService.validate(item.requestCode)
        .then((response) => {
          this.vCue = true;
          this.vMessage2 = "Real price:" + response.data[0].realPrice;
          this.vMessage3 = "Real volume:" + response.data[0].realVolume;
          this.vMessage4 = "Delivery rate:" + response.data[0].deliveryRate;
          this.loader = "";
          this.validations = response.data;
          console.log("VVVVVVPPPPP", this.validations, item);
          this.$store.commit("block/saveV", item);
        })
        .catch((e) => {
          console.log("There was an error " + e);
          this.vMessage = e;
          this.loader = "";
          this.vError = true;
        });
      this.Apps.finalPay();
    },
    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    compareTime(time) {
      return moment(
        new Date(`${time.requestDateTo} ${time.requestTimeTo}`)
      ).isAfter(this.now);
    },
    userHistory() {
      this.Apps.userHistory();
    },
    offerHistory() {
      this.Apps.offerHistory();
    },
    buyCoin() {
      window.open("https://sepoliafaucet.com/");
    },
  },
  async mounted() {
    OfferDataService.getOfferList()
      .then((response) => {
        this.offerStatus = response.data.slice(-30);
      })
      .catch((e) => {
        console.log("There was an error " + e);
      });
    OfferDataService.getReqList()
      .then((response) => {
        this.reqStatus = response.data.slice(-30);
      })
      .catch((e) => {
        console.log("There was an error " + e);
      });

    OfferDataService.getList()
      .then((response) => {
        this.offersList = response.data;
        console.log("PAPAPAPA", this.offersList)
      })
      .catch((e) => {
        console.log("There was an error " + e);
      });
    OfferDataService.getConsumption()
      .then((response) => {
        this.consumption = response.data.slice(-30);
      })
      .catch((e) => {
        console.log("There was an error " + e);
      });
    OfferDataService.getProduction()
      .then((response) => {
        this.production = response.data.slice(-30);
      })
      .catch((e) => {
        console.log("There was an error " + e);
      });
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.page-container-summary {
  min-height: 100vh;
  background: #f8fcff;
  padding-bottom: 50px;
  margin-top: -100px;
}

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #f8fcff;
}

.balance-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 10px;
}

.balance1 {
  flex: 1;
  display: flex;
  padding: 20px;
  position: relative;
  flex-direction: column;
  margin-bottom: 20px;
  border-radius: 10px;
  background: rgba(38, 56, 88, 1);
  background: -moz-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(38, 56, 88, 1)),
    color-stop(57%, rgba(38, 56, 88, 1)),
    color-stop(75%, rgba(71, 87, 115, 1)),
    color-stop(100%, rgba(153, 164, 180, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#263858', endColorstr='#99a4b4', GradientType=1 );
}

.summary-icon {
  color: #fff !important;
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.summary-header {
  color: #fff;
}

.balance {
  margin: 20px 0;
  font-size: 1.3em;
  color: #fff;
  font-weight: 700;
}

.conversion {
  font-size: 0.8em;
  color: #999;
}

.summary-upper {
  display: flex;
  justify-content: space-between;
}

.summary-left,
.summary-right {
  width: 48%;
  display: flex;
  flex-direction: column;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span,
.validate-button span {
  color: #fff;
  text-transform: none;
}

.offer-middle {
  margin: 60px 0 250px 0;
  width: 100%;
  height: 500px;
}

.summary-middle {
  display: flex;
  margin: 60px 0;
}

.summary-graph {
  flex: 1;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0);
  padding: 0 20px;
  overflow-x: hidden;
}

.summary-middle-table {
  width: 50%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.buy-wrapper th {
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.buy-wrapper td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.transactions {
  width: 100%;
}

.summary-tab .text-start {
  font-size: 12px !important;
}

.table-headline2 {
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
}
</style>
